import securityDetails from "./../../../../assets/images/accounts/sec_tick.PNG";
export default function ProfileDetails() {
  return (
    <div>
      <h4 className="mx-4 my-3 main-profile-header">Security Details</h4>
      <div className="card mx-4">
        <div className="card-body">
          <div className="">
            <div className="row">
              <div className="col-4">
                <h3 className="card-title my-1">Password</h3>
                {/* <h4 className="label-block">Last Edited 10 Days Ago</h4> */}
              </div>
              <div className="col-4"></div>
              <div className="col-4"></div>
            </div>
            <div className="row">
              <div className="col-4"></div>
              <div style={{ textAlign: "center" }} className="col-4">
                <img src={securityDetails} style={{ margin: "0 auto" }} alt="Trademo - Security Details" />
                <br />
              </div>
              <div className="col-4"></div>
            </div>
            <div className="row mt-3">
              <div className="col-3"></div>
              <div style={{ textAlign: "center" }} className="col-6">
                <p>Your password has been successfully updated.</p>
              </div>
              <div className="col-3"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
